"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationIcon = void 0;
var Apps_1 = __importDefault(require("@mui/icons-material/Apps"));
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var constants_1 = require("../../constants");
var NavigationIcon = function (props) {
    var setPopoverOpen = props.setPopoverOpen;
    return (react_1.default.createElement(material_1.IconButton, { onClick: setPopoverOpen, size: "large", "data-testid": constants_1.ModularNavigationWidgetTestIds.navigationIcon },
        react_1.default.createElement(Apps_1.default, null)));
};
exports.NavigationIcon = NavigationIcon;
